"use client";

import { useBridgeScannerFiltersStore } from "@/features/bridge-scanner/stores/filters.store";
import type { DateRangeFilter } from "@/types/bridge-scanner.types";
import { extractParamsAsMap } from "@/utils/searchParamsToState.util";
import dayjs from "dayjs";
import { useEffect } from "react";

/**
 * Custom hook that initializes bridge scanner filter parameters from URL search parameters.
 * This hook syncs the URL query parameters with the bridge scanner's internal state.
 *
 * @remarks
 * The hook performs the following operations:
 * - Retrieves current search parameters from the URL
 * - Converts search parameters to an object
 * - Initializes the bridge scanner store with these parameters
 *
 * @returns void
 */
const useBridgeScannerFilterInit = () => {
  const { initQueryParams } = useBridgeScannerFiltersStore();

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const filterParams = extractParamsAsMap(searchParams);
    const fromDate = filterParams.get("from_timestamp")?.[0];
    const toDate = filterParams.get("to_timestamp")?.[0];

    filterParams.delete("from_timestamp");
    filterParams.delete("to_timestamp");

    const dateRange: DateRangeFilter = [
      fromDate ? dayjs.unix(Number(fromDate)).toDate() : null,
      fromDate ? dayjs.unix(Number(toDate)).toDate() : null,
    ];

    initQueryParams(filterParams, dateRange);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

export default useBridgeScannerFilterInit;
